module.exports = __webpack_public_path__ + "img/FunctionModule.d0201977.jpg";